import React, { useState, useRef } from 'react'
import { Form, useNavigate } from 'react-router-dom';
import '../components/css/Login.css'
import LoginImage from '../images/login_image.png';
import LoginImage2 from '../images/login_image2.png';
import LoginImage3 from '../images/login_image3.jpg';
import LoginImageSliderGradient from '../images/login_slider_image_gradient.png';
import InoxLogo from '../images/inox_logo.png';
import * as actions from '../actions/AuthActions';
import axios from "axios";
import { useDispatch } from "react-redux";
import { Card, Image, Button, Spinner, Form as BootstrapForm } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Login = (props) => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [loginInfoShow, setLoginInfoShow] = useState(false);
    const [selectedRole, setSelectedRole] = useState("Select a Role");

    const form = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const login = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        // const data = {"username": username, "password": password, "role": selectedRole}
        const data = {"username": username, "password": password}
        const response = await actions.Login(data);

        if (response) {
            setIsSubmitting(false);
            navigate("/dashboard")
        } else if (response) {
            navigate("")
            setIsSubmitting(false);
            toast.error("Credeintials are incorrect !")
        }
        else {
            setIsSubmitting(false);
            toast.error("Credeintials are incorrect !")
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            login(e);
        }
    };

    return (
        <div class="container-fluid login-page">
            <ToastContainer></ToastContainer>
            <div class="row login-bg-gradient">
                <div class="col-md-6 image-section d-none d-md-block">
                    <button type="submit" class="btn login-btn-info" onClick={() => setLoginInfoShow(!loginInfoShow)}>i</button>
                    <div className={`slide-card ${loginInfoShow ? "show" : ""}`}>
                        <Card style={{ height: "88vh", borderRadius: "30px" }}>
                        <Card.Body>
                            <Card.Title>Vessel Schedule</Card.Title>
                            <Card.Text>This will include card list which include vessel schedule.</Card.Text>
                        </Card.Body>
                        </Card>
                    </div>

                    <div id="carouselExampleCaptions" class="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"></button>
                        </div>

                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={LoginImage} class="d-block w-100" alt="Slide 1" />
                                <div class="carousel-caption">
                                    <h2 className="carousel-caption-title">Building the future</h2>
                                    <p class="carousel-caption-description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <img src={LoginImage2} class="d-block w-100" alt="Slide 2" />
                                <div class="carousel-caption">
                                    <h2 className="carousel-caption-title">Delivering the world</h2>
                                    <p class="carousel-caption-description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <img src={LoginImage3} class="d-block w-100" alt="Slide 3" />
                                <div class="carousel-caption">
                                    <h2 className="carousel-caption-title">Endless Possibilities</h2>
                                    <p class="carousel-caption-description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 login-container">
                    <div class="login-box">
                        <div class="text-center mb-4">
                            <Image src={InoxLogo} className='mb-4' alt="Logo" width="150" />
                        </div>
                        <p>Welcome Back</p>
                        <h4>Log In to your Account</h4>
                        <p class="text-muted my-5">To keep connected with us login with your role and username</p>
                        <form>
                            {/* <div class="mb-3">
                                <label class="form-label">Role</label>
                                <button class="btn btn-secondary dropdown-toggle select-input" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span id="selected_role">{selectedRole}</span> 
                                    <span class="fa fa-caret-down"></span>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" onClick={(e) => setSelectedRole(e.target.innerText)}>
                                    <a class="dropdown-item">Administrator</a>
                                    <a class="dropdown-item">Agent</a>
                                    <a class="dropdown-item">Customer</a>
                                    <a class="dropdown-item">Depot Agent</a>
                                    <a class="dropdown-item">Sales</a>
                                    <a class="dropdown-item">Surveyor</a>
                                </div>
                            </div> */}
                            <div class="mb-3">
                                <label class="form-label">Email / Username / Mobile</label>
                                <input type="text" class="form-control text-input" name="username" placeholder="Enter Your User Name" onChange={(e) => setUsername(e.target.value)} autoComplete='off'/>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Password</label>
                                <input type={showPassword?"text":"password"} class="form-control text-input" name="password" placeholder="Enter Your Password" onChange={(e) => setPassword(e.target.value)}/>
                                <i className="fa fa-eye show-password-btn" onClick={() => setShowPassword(!showPassword)}></i>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <input type="checkbox" id="remember" />
                                    <label for="remember" className='px-2'>Remember me</label>
                                </div>
                                <a href="#" class="text-decoration-none text-dark">Forgot Password?</a>
                            </div>
                            <button onClick={login} class="btn btn-login mt-4">
                                {isSubmitting?
                                    <Spinner className="mr-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                                :
                                    "Login"
                                }
                            </button>
                        </form>
                        <div className="my-4">
                            <div className="row">
                                <div className="col text-center"><i className="fa fa-facebook fa-lg cursor-pointer text-inox-green" title="Facebook"></i></div>
                                <div className="col text-center"><i className="fa fa-google fa-lg cursor-pointer text-inox-green" title="Gmail"></i></div>
                                <div className="col text-center"><i className="fa fa-linkedin fa-lg cursor-pointer text-inox-green" title="Linked In"></i></div>
                                <div className="col text-center"><i className="fa fa-instagram fa-lg cursor-pointer text-inox-green fw-bold" title="instagram"></i></div>
                            </div>
                        </div>
                        <div className="my-5 text-center">
                            <a href="/getaquote" className="btn btn-inox-green text-white text-decoration-none btn-quote">
                                <span>Get a Quote</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
